import React, { useEffect, useRef } from "react";
import "../../css/ourproducts.css";
import products from "../data/ncpaint";
import { FaArrowRight, FaPlus, FaWhatsapp } from 'react-icons/fa';

function Products({ setShowModal }) {
  const scrollRef = useRef(null);

  const handleOpenModal = (product) => {
    setShowModal(true);
  };

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let animationId;
    const scroll = () => {
      if (scrollContainer.scrollLeft >= (scrollContainer.scrollWidth - scrollContainer.clientWidth)) {
        scrollContainer.scrollLeft = 0; // Reset scroll if it reached the end
      } else {
        scrollContainer.scrollLeft += 1;
      }
      animationId = requestAnimationFrame(scroll);
    };

    animationId = requestAnimationFrame(scroll);

    const handleMouseEnter = () => cancelAnimationFrame(animationId);
    const handleMouseLeave = () => {
      animationId = requestAnimationFrame(scroll);
    };

    scrollContainer.addEventListener('mouseenter', handleMouseEnter);
    scrollContainer.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      cancelAnimationFrame(animationId);
      if (scrollContainer) {
        scrollContainer.removeEventListener('mouseenter', handleMouseEnter);
        scrollContainer.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, []);

  return (
    <section className="featured-section" id="product">
      <div className="container">

        {/* Header Section */}
        <div className="text-center mb-5">
          <div className="d-inline-flex align-items-center gap-2 mb-2">
            <div style={{ width: "40px", height: "3px", backgroundColor: "#e86229", borderRadius: "2px" }}></div>
            <h6 className="fw-bold text-uppercase mb-0" style={{ color: '#e86229', letterSpacing: '2px' }}>
              Top Product Gallery
            </h6>
            <div style={{ width: "40px", height: "3px", backgroundColor: "#e86229", borderRadius: "2px" }}></div>
          </div>
          <h2 className="fw-bold display-5 our-products-heading" style={{ color: '#1a2f55', fontFamily: "'Georgia', serif" }}>
            Explore Our Premium Products
          </h2>
        </div>



        {/* Cards Row */}
        <div className="featured-cards-scroll" ref={scrollRef}>
          {products && products.length > 0 ? (
            products.map((product, idx) => (
              <div key={idx} className="featured-card" style={{ cursor: "pointer" }} onClick={() => handleOpenModal(product)}>
                <span className="new-badge">NEW</span>

                <div className="card-image-container">
                  <img src={product.img} alt={product.name} />
                </div>

                <div className="card-category">{product.brand}</div>
                <h3 className="card-title">{product.name}</h3>
                <p className="card-desc">{product.features ? product.features[0] : product.color}</p>

                <div className="card-footer">
                  <a href="#view-details" className="view-details" onClick={(e) => { e.preventDefault(); handleOpenModal(product); }}>
                    View Details <FaArrowRight size={10} />
                  </a>
                  <FaPlus className="plus-btn" onClick={() => handleOpenModal(product)} />
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-muted py-5 w-100">No products found</div>
          )}
        </div>

        {/* Bottom Button */}
        <div className="download-btn-container">
          <a
            href="https://wa.me/917827552889?text=Hello%2C%20I%20am%20interested%20in%20your%20PCD%20Pharma%20Franchise%20opportunity."
            target="_blank"
            rel="noopener noreferrer"
            className="download-btn"
          >
            <FaWhatsapp size={28} />
            Chat Now on WhatsApp
          </a>
        </div>
      </div>

    </section>
  );
}

export default Products;
